export default {
    csManagement: {
        page: {
            title: 'CS 管理中心',
            description: '管理租户配额、文档总量和 Token 消耗控制',
        },
        quota: {
            searchPlaceholder: '搜索租户 ID',
            typePlaceholder: '配额类型',
            search: '搜索',
            create: '新增配额',
            tenantId: '租户 ID',
            quotaType: '配额类型',
            typeDocument: '文档总量',
            typeToken: 'Token 消耗总量',
            quotaLimit: '配额上限',
            quotaUsed: '已使用',
            contractPeriod: '合同期',
            contractStart: '合同开始',
            contractEnd: '合同结束',
            status: '状态',
            statusActive: '生效中',
            statusExpired: '已过期',
            remark: '备注',
            action: '操作',
            edit: '编辑',
            delete: '删除',
            createTitle: '新增配额',
            editTitle: '编辑配额',
            cancel: '取消',
            confirm: '确认',
        },
    },
}
